// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected {
  --mat-expansion-container-background-color: var(--app-selection-bg);
  background-color: var(--app-selection-bg);
}

.header-content-width-45 { max-width: 45%; }
.header-content-width-60 { max-width: 60%; }
.header-content-width-65 { max-width: 65%; }
.item-selection-header-content, .item-selection-action { display: table-cell; }
.app-mini-button { min-width: 84px; }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/item-selection-accordion/item-selection-accordion.component.css"],"names":[],"mappings":"AAAA;EACE,mEAAmE;EACnE,yCAAyC;AAC3C;;AAEA,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,yDAAyD,mBAAmB,EAAE;AAC9E,mBAAmB,eAAe,EAAE","sourcesContent":[".selected {\n  --mat-expansion-container-background-color: var(--app-selection-bg);\n  background-color: var(--app-selection-bg);\n}\n\n.header-content-width-45 { max-width: 45%; }\n.header-content-width-60 { max-width: 60%; }\n.header-content-width-65 { max-width: 65%; }\n.item-selection-header-content, .item-selection-action { display: table-cell; }\n.app-mini-button { min-width: 84px; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
